import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M22.0312 19H20.0312V20.042H22.0312V19Z" }), jsx("path", { fill: "currentColor", d: "M12.0443 2.81055L2.03125 9.27155V9.64155L5.98125 12.1905V17.5805L6.14325 17.8295C6.22725 17.9585 8.24725 21.0005 12.0352 21.0005C15.8232 21.0005 17.7633 17.9375 17.8433 17.8075L17.9902 17.5665V12.2665L20.0323 10.9495V18.0005H22.0323V9.25455L12.0443 2.81055ZM15.9893 16.9695C15.5613 17.5325 14.2353 19.0005 12.0343 19.0005C9.83325 19.0005 8.43425 17.5255 7.98125 16.9565V13.4805L12.0443 16.1025L15.9893 13.5575V16.9695ZM12.0443 13.7225L5.43325 9.45655L12.0443 5.19055L18.6553 9.45655L12.0443 13.7225Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconEducation = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconEducation.displayName = "IconEducation";

export { IconEducation };
